import Box from '@mui/material/Box';
import MuiDrawer, { type DrawerProps } from '@mui/material/Drawer';

import { DrawerHeader } from '../DrawerHeader/DrawerHeader';

type Props = DrawerProps & {
  padding?: 'small' | 'medium';
};

export const Drawer = ({ children, padding = 'medium', ...rest }: Props) => {
  return (
    <MuiDrawer {...rest}>
      <Box
        sx={{
          height: '100%',

          p: {
            sm: padding === 'medium' ? 4 : 1,
            xs: padding === 'medium' ? 3 : 1,
          },
        }}
      >
        {children}
      </Box>
    </MuiDrawer>
  );
};

Drawer.Header = DrawerHeader;
